export const VERSION = '3';
export default VERSION;